// يبني حمولة header لـ POST /docs من حالة النموذج.
export const buildHeader = (head, plan, today) => ({
  date: today,
  needed_by: head.needed_by || today,
  supplier_id: head.supplier_id || null,
  currency: head.currency || "AED",
  payment_terms_kind: head.payment_terms_kind || null,
  payment_terms_days: head.payment_terms_days ?? null,
  payment_start_timing: head.payment_start_timing
    || (head.payment_terms_kind === "advance" ? "on_order_signed"
      : head.payment_terms_kind === "cod" ? "after_delivery" : "after_invoice"),
  branch_id: head.delivery_branch_id || null,
  delivery_branch_id: head.delivery_branch_id || null,
  delivery_warehouse_id: head.delivery_warehouse_id || null,
  discount_percent: head.discount_percent || null,
  discount_amount: head.discount_amount || null,
  notes: head.notes || null,
  warranty_type: head.warranty_enabled ? (head.warranty_type || null) : null,
  warranty_months: head.warranty_enabled && head.warranty_months ? Number(head.warranty_months) : null,
  warranty_notes: head.warranty_enabled ? (head.warranty_notes || null) : null,
  payment_installments: plan.filter((row) => row.percent || row.amount || row.days),
});
